import { Controller } from "@hotwired/stimulus"
import React, { Suspense } from "react"
import { render, unmountComponentAtNode } from "react-dom"
import { Loading, ModalContainer } from "web/components"
import { AppProviders, LibraryProviders } from "web/Providers"
import ListLayouts from "web/app/Settings/Customization/Layouts/List"

export default class ListLayoutsController extends Controller {
  static values = {
    subjectType: String,
    topicId: Number,
  }

  initialize() {
    global.React = React
  }

  disconnect() {
    unmountComponentAtNode(this.element)
  }

  connect() {
    const topicId = this.topicIdValue || null

    render(
      <Suspense fallback={<Loading />}>
        <LibraryProviders>
          <AppProviders>
            <ListLayouts
              subjectType={this.subjectTypeValue}
              topicId={topicId}
            />
            <ModalContainer />
          </AppProviders>
        </LibraryProviders>
      </Suspense>,
      this.element
    )
  }
}
